import { put } from "../../service/api";

const UpdateMerchantProfile = async (merchantId, data) => {
  try {
    return await put(`/merchant/${merchantId}/profile`, data);
  } catch (error) {
    console.error("Error UpdateMerchantProfile:", error);
    throw error;
  }
};

export default UpdateMerchantProfile;
